var map = {
	"./BackBtnLayout.vue": 2036,
	"./BaseLayout.vue": 1148,
	"./ClinicHistorySectionsSidebar.vue": 2040,
	"./ForumNavbar.vue": 2044,
	"./HealthyHabitsLayout.vue": 2057,
	"./InternalReducedLayout.vue": 2061,
	"./Opensalud360Layout.vue": 2066,
	"./OpensaludEmpresasLayout.vue": 2073,
	"./OpensaludLayout.vue": 2077,
	"./OpensaludPacientesLayout.vue": 2081,
	"./OpensaludProfesionalesLayout.vue": 2085,
	"./PrivateLayout.vue": 2089,
	"./PublicExtendedLayout.vue": 2121,
	"./PublicLayout.vue": 2125,
	"./PublicMenuLayout.vue": 2129,
	"./PublicMenuLayoutV2.vue": 177,
	"./PublicMobileMenuLayout.vue": 2133,
	"./PublicReducedLayout.vue": 1227,
	"./PublicReducedLayoutDynamic.vue": 2140,
	"./patient/GoFreedom.vue": 2144,
	"./patient/GoOpensaludpass.vue": 2148,
	"./patient/GoTeleconsultation.vue": 2152,
	"./patient/GoTmc.vue": 2156,
	"./patient/GoWellwo.vue": 2160,
	"./patient/SearchTab.vue": 1332,
	"./professional/customHeader.vue": 1306,
	"./professional/customaFooter.vue": 2164
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2035;


//////////////////
// WEBPACK FOOTER
// ./src/components/layouts [A-Z]\w+\.(vue|js)$
// module id = 2035
// module chunks = 120